import { render, staticRenderFns } from "./MallSelector.vue?vue&type=template&id=7cf0eadb&scoped=true&"
import script from "./MallSelector.vue?vue&type=script&lang=ts&"
export * from "./MallSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MallSelector.vue?vue&type=style&index=0&id=7cf0eadb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf0eadb",
  null
  
)

export default component.exports